import React from 'react';

const Footer = () => {
  return (
    <div className="bg-white border-t border-gray-200 py-4">
      <div className="max-w-7xl mx-auto px-4">
        <p className="text-center text-sm text-gray-600">
          Copyright © The Oncall Bot LLC 2025
        </p>
      </div>
    </div>
  );
};

export default Footer;